

class FuelSurchagesAllController {
	/*@ngInject*/
	constructor(Auth, $state, $stateParams, User, UsersService, Modal, $translate, $location, FuelSurchargeService, UserService, BranchService, $q, $scope) {
		this.Auth = Auth
		this.User = User
		this.Modal = Modal
		this.FuelSurchargeService = FuelSurchargeService
		this.UserService = UserService
		this.BranchService = BranchService
		this.$q = $q
		this.$scope = $scope
		this.$state = $state
		this.$stateParams = $stateParams
		this.$location = $location
		this.permissions = this.Auth.permission()


		this.loading = false //true
		this.fuelSurcharges = []
		this.page = 1
		this.total = 0
		this.pageLimit = 10
		this.maxPages = 10
		this.hasACL = {}
		// this.pagination = {
		// 	page: 1,
		// 	total: 0,
		// 	pageLimit: 10,
		// 	maxPages: 10
		// }
		this.sortColumn = "customerName";
		this.reverseSort = false;

		this.searchObj = {
			searchText: '',
			status: null
		};

		this.statusList = [
			{
				label: $translate.instant('location_types.All'),
				value: null,
			},
			{
				label: $translate.instant('common.active'),
				value: 1
			},
			{
				label: $translate.instant('common.inactive'),
				value: 0
			}]
	}

	$onInit() {
		let pageId = this.$stateParams.page;
		if (pageId > 0) {
			this.page = pageId
		}

		let fuelSurchargesACL = this.User.getACL("fuel_surcharges");
		if (fuelSurchargesACL && fuelSurchargesACL.length) {
			fuelSurchargesACL.forEach(key => {
				this.hasACL[key] = true;
			});
		}
		this.loadData()
	}

	applyFilter() {
		this.page = 1;
		this.loadData()
	}
	pageChange() {
		let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
		this.$stateParams.page = this.page;
		this.$location.path(newUrl)
		this.loadData();
	}


	loadData() {
		this.loading = true;
		this.fuelSurcharges = [];
		this.FuelSurchargeService.all(this.searchObj.searchText, this.searchObj.status, (this.page - 1) * this.pageLimit, this.pageLimit)
			.then(({ data, count }) => {
				this.total = count;
				this.fuelSurcharges = data;
				this.loading = false;
			})
			.catch((err) => {
				this.loading = false
				this.error = err.message
			})
	}

	edit(fuelSurcharg) {
		this.$state.go('fuel_surcharges.edit', ({
			id: fuelSurcharg.id
		}))
	}
	onCustomerPageChange(fuelSurcharge) {
		this.getFuelSurchargeCustomers(fuelSurcharge)
	}

	sortData(column, fuelSurcharge) {
		this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
		this.sortColumn = column;

		fuelSurcharge.customerFilter.sortingKey = column;
		fuelSurcharge.customerFilter.sortingDir = this.reverseSort;
		this.getFuelSurchargeCustomers(fuelSurcharge);
	}

	expandFuelSurchageCustomer(fuelSurcharge) {
		fuelSurcharge.expanded = !fuelSurcharge.expanded;
	}
	getFuelSurchargeCustomers(fuelSurcharge) {
		if (fuelSurcharge.expanded) {
			let defaultFilter = {
				fuelSurchargeId: fuelSurcharge.id,
				sortingKey: this.sortColumn, //'fuelSurchargeId',
				sortingDir: this.reverseSort,
				limit: 10,
				page: 1
			}
			if (!fuelSurcharge.customerFilter) {
				fuelSurcharge.customerFilter = defaultFilter
			}
			fuelSurcharge.customerFilter.offset = (fuelSurcharge.customerFilter.page - 1) * fuelSurcharge.customerFilter.limit

			fuelSurcharge.isCustomerLoading = true;
			this.FuelSurchargeService.fuelSurchageCustomers({
				'fuelSurchargeId': fuelSurcharge.id,
				'sortingKey': fuelSurcharge.customerFilter.sortingKey,
				'sortingDir': fuelSurcharge.customerFilter.sortingDir,
				'limit': fuelSurcharge.customerFilter.limit,
				'offset': fuelSurcharge.customerFilter.offset
			})
				.then(({ data, count }) => {
					fuelSurcharge.isCustomerLoading = false;
					fuelSurcharge.totalCustomers = count;
					fuelSurcharge.customerList = data;
				})
				.catch((err) => {
					fuelSurcharge.isCustomerLoading = false
					fuelSurcharge.customerError = err.message
				})
		} else {
			fuelSurcharge.customerFilter.page = 1
		}
	}

	expandFuelSurchageLocation(fuelSurcharge) {
		fuelSurcharge.expandedLocation = !fuelSurcharge.expandedLocation;
	}
	getFuelSurchargeLocations(fuelSurcharge) {
		if (fuelSurcharge.expandedLocation) {
			let defaultFilter = {
				fuelSurchargeId: fuelSurcharge.id,
				sortingKey: 'fuelSurchargeId',
				sortingDir: false,
				limit: 10,
				page: 1
			}
			if (!fuelSurcharge.locationFilter) {
				fuelSurcharge.locationFilter = defaultFilter
			}
			fuelSurcharge.locationFilter.offset = (fuelSurcharge.locationFilter.page - 1) * fuelSurcharge.locationFilter.limit

			fuelSurcharge.isLocationLoading = true;
			this.FuelSurchargeService.fuelSurchargeLocations({
				'fuelSurchargeId': fuelSurcharge.id,
				'sortingKey': fuelSurcharge.locationFilter.sortingKey,
				'sortingDir': fuelSurcharge.locationFilter.sortingDir,
				'limit': fuelSurcharge.locationFilter.limit,
				'offset': fuelSurcharge.locationFilter.offset
			})
				.then(({ data, count }) => {
					fuelSurcharge.isLocationLoading = false
					fuelSurcharge.totalLocations = count;
					fuelSurcharge.locationList = data
				})
				.catch((err) => {
					fuelSurcharge.isLocationLoading = false
					fuelSurcharge.locationError = err.message
				})
		} else {
			fuelSurcharge.locationFilter.page = 1
		}
	}

	showLocations(fuelSurcharg, customerId) {
		this.Modal.FuelSurchargeLocations(fuelSurcharg, customerId, ({ modal }) => {
			modal.close()
		}, ({ modal }) => {
			this.isLoading = false;
			if (modal) modal.close();
		});
	}

	goToCustomer = (customerId) => {
		this.$state.go('customer.edit', ({
			id: customerId
		}))
	}
}

export default FuelSurchagesAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/all/fuel_surcharges.all.controller.js